module.exports = require("@material-ui/icons/LastPage");